export const MaterialName = "VEC_AWS_089";
export const GuidewayAmount = "VEC_ANZ_089";
export const CarriageAmount = "VEC_AWS_089";
export const SizeCode = "VEC_BGR_089";

export const Sealing = "VEC_ET_089";
export const Accuracy = "VEC_GEN_089";
export const Preload = "VEC_VSP_089";

export const DesignType_Series = "VB_MKB_089";
export const DesignType_SizeCode = "VB_BGR_089";
export const DesignType_Version = "VB_VER_089";
export const DesignType_Carriage = "VB_WAU_089";

export const GuidewayDesign = "VEC_SAF_089";
export const CarriageDesign = "VEC_WAU_089";

export const GuidewayLength = "VEC_KWL_089";
export const GuidewayLengthMin = "VEC_LMIN_089";
export const GuidewayLengthMax = "VEC_LMAX_089";

export const AL = "VEC_AAL_089";
export const AR = "VEC_AAR_089";

export const AlMinRecommended = "VEC_AL_MIN_089";
export const AlMaxRecommended = "VEC_AL_MAX_089";
export const ArMinRecommended = "VEC_AR_MIN_089";
export const ArMaxRecommended = "VEC_AR_MAX_089";

export const AlarHardMax = "VEC_JL_089"; //"VJL_089";

export const PartSizing = "FAKE_SIZING"; // Possible values: No parts, automatic split, manual split
export const PartAmount = "FAKE_PART_AMOUNT";
export const Closure = "FAKE_CLOSURE";
